import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  headersBase,
  headersType,
} from "../../../utils/constants/headersForApi";

export const serviceTaskApi = createApi({
  reducerPath: "serviceTasks",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["serviceTasks", "serviceTask"],
  endpoints: (builder) => ({
    getServiceTasks: builder.query({
      query: ({
        startRow = 0,
        endRow = 100,
        filter = {},
        sort = [],
        serviceId = "",
      }) => ({
        url: `/admin/ServiceTask/list?serviceId=${serviceId}`,
        method: "POST",
        headers: headersType(),
        body: {
          startRow,
          endRow,
          filter,
          sort,
        },
      }),
      providesTags: ["serviceTasks"],
    }),
    getServiceTaskById: builder.query({
      query: (id) => ({
        url: `/admin/ServiceTask/${id}`,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: (result, error, id) => [{ type: "serviceTask", id }],
    }),
    createServiceTask: builder.mutation({
      query: (serviceTask) => ({
        url: `/admin/ServiceTask`,
        method: "POST",
        headers: headersType(),
        body: serviceTask,
      }),
      invalidatesTags: ["serviceTasks"],
    }),
    updateServiceTask: builder.mutation({
      query: ({ id, ...serviceTask }) => ({
        url: `/admin/ServiceTask/${id}`,
        method: "PUT",
        headers: headersType(),
        body: serviceTask,
      }),
      invalidatesTags: (result, error, { id }) => [
        "serviceTasks",
        { type: "serviceTask", id },
      ],
    }),
    deleteServiceTask: builder.mutation({
      query: (id) => ({
        url: `/admin/ServiceTask/${id}`,
        method: "DELETE",
        headers: headersBase(),
      }),
      invalidatesTags: (result, error, id) => [
        "serviceTasks",
        { type: "serviceTask", id },
      ],
    }),
  }),
});

export const {
  useGetServiceTasksQuery,
  useGetServiceTaskByIdQuery,
  useCreateServiceTaskMutation,
  useUpdateServiceTaskMutation,
  useDeleteServiceTaskMutation,
} = serviceTaskApi;
